import { getFontSize } from '../../../../../constants/fontSizes';

export const faqAccordionStyles = {
  accordionContainer: {
    borderRadius: {xs: '20px', lg: '40px'},
    gap: '4px',
    padding: {xs: '20px', lg: '35px 40px'},
    backgroundColor: '#FFFFFF0D',
    display: 'flex',
    flexDirection: 'column',
  },
  accordion: {
    backgroundColor: 'transparent !important',
    boxShadow: 'none !important',
    '&:not(:last-child)': {
      borderBottom: '1px solid #FFFFFF1C',
      paddingBottom: '10px',
    },
    '&.MuiPaper-root': {
      backgroundColor: 'transparent !important',
      boxShadow: 'none !important',
      '&::before': {
        display: 'none !important',
      },
    },
    '&.Mui-elevation1': {
      boxShadow: 'none !important',
      '&::before': {
        display: 'none !important',
      },
    },
    '&.Mui-elevation': {
      boxShadow: 'none !important',
      '&::before': {
        display: 'none !important',
      },
    },
  },
  accordionSummary: {
    backgroundColor: 'transparent',
    padding: 0,
    fontSize: getFontSize(16),
    minHeight: 'auto',
    '&.Mui-expanded': {
      minHeight: 'auto',
    },
    '& .MuiAccordionSummary-content': {
      margin: {xs: '5px 0', lg: '16px 0'},
      '&.Mui-expanded': {
        margin: '16px 0',
      },
    },

  },
  accordionTitle: {
    color: '#e2e2e2',
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: getFontSize(22),
    lineHeight: '28px',
    letterSpacing: '-0.01em',
    flex: 1,
  },
  expandIcon: {
    color: '#e2e2e2',
    fontSize: getFontSize(32),
  },

  accordionDetails: {
    backgroundColor: 'transparent !important',
    padding: '0 0 16px 0',
  },
  accordionContent: {
    color: '#e2e2e2',
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: getFontSize(18),
    lineHeight: '1.6',
  },
  fadeIn: (isVisible, delay) => ({
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
    transition: `opacity 0.6s ease-out ${delay}s, transform 0.6s ease-out ${delay}s`,
  }),
};

